import { tokens } from '@welbe/web-design-system';
import { Exams } from './components/Exams/Exams';
import { Lecture } from './components/Lecture/Lecture';
import { Sections } from './components/Sections/Sections';
import { Workshops } from './components/Workshops/Workshops';
import { TabType } from './DrawerEmployees.types';

export const defaultTabs: TabType[] = [
	{ id: 0, key: 'exams', name: 'Estudios', component: Exams, data: [] },
	{ id: 1, key: 'chats', name: 'Pláticas', component: Lecture, data: [] },
	{ id: 2, key: 'workshops', name: 'Talleres', component: Workshops, data: [] },
	{ id: 3, key: 'sessions', name: 'Sesiones', component: Sections, data: [] },
];

export const months = [
	'enero',
	'febrero',
	'marzo',
	'abril',
	'mayo',
	'junio',
	'julio',
	'agosto',
	'septiembre',
	'octubre',
	'noviembre',
	'diciembre',
];

export const defaultOptions = [
	{ status: 'pendent', id: 'pendent', name: 'Pendiente' },
	{
		status: 'notParticipating',
		id: 'notParticipating',
		name: 'No participará',
	},
	{ status: 'inProgress', id: 'inProgress', name: 'En curso' },
	{ status: 'finished', id: 'finished', name: 'Completado' },
	{ status: 'notCompleted', id: 'notCompleted', name: 'No completo' },
];

export const multipleOption = {
	status: 'pendent',
	id: 'several',
	name: 'Varios',
};

export const statusInfo = {
	pendent: tokens.color_gray_medium,
	notParticipating: tokens.color_alert,
	inProgress: tokens.color_primary,
	finished: tokens.color_welbe,
	notCompleted: tokens.color_toast_error,
};
